import { AccountBalancePaymentTransaction } from '@/components/transactions/AccountBalancePaymentTransaction';

export const AccountBalancePaymentPage = () => {
    return <AccountBalancePaymentTransaction />;
};
